import PayableInvoicesTable from "../tables/PayableInvoicesTable";
import { Stack } from '@mui/material';
import PassiveInvoicesFilter from "../filters/PayableInvoicesFilter";
import { useHasScope } from "../../../../../config/globalConfig";
import { VIEW_PAYABLE } from "../../../utils/FinanceScope";
import NotAuthorizedDialog from "../../../../authentication/component/NotAuthorizedDialog";

const PayableInvoices = () => {

    const hasScope = useHasScope;

    if (!hasScope(VIEW_PAYABLE)){ 
        return <NotAuthorizedDialog/>
    }
    
    return (
            <Stack direction={"column"} spacing={2} margin={"16px"}>
                <PassiveInvoicesFilter/>
                <PayableInvoicesTable/>
            </Stack>
    );
}
export default PayableInvoices;